// FAKE (demo) signup forms — used only while no real Contact Form 7 shortcode
// is set in the Customizer. Nothing is sent anywhere: this script just fakes
// the whole flow (field validation, "sending" state, success/error toast) so
// the form looks and behaves like the final one. Every .js-newsletter-form on
// the page works independently.
document.addEventListener("DOMContentLoaded", function () {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var SEND_DELAY = 900; // fake network latency, ms
  var TOAST_TIME = 4500;

  // ─── Fake notification (toast) ───────────────────────────────────────────
  var stack = null;
  function toast(type, title, text) {
    if (!stack) {
      stack = document.createElement("div");
      stack.className = "rs-toasts";
      stack.setAttribute("aria-live", "polite");
      stack.setAttribute("role", "status");
      document.body.appendChild(stack);
    }

    var el = document.createElement("div");
    el.className = "rs-toast rs-toast--" + type;

    var icon = document.createElement("span");
    icon.className = "rs-toast__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = type === "success" ? "✓" : "!";

    var body = document.createElement("div");
    body.className = "rs-toast__body";
    var strong = document.createElement("strong");
    strong.textContent = title;
    var p = document.createElement("span");
    p.textContent = text;
    body.appendChild(strong);
    body.appendChild(p);

    var close = document.createElement("button");
    close.type = "button";
    close.className = "rs-toast__close";
    close.setAttribute("aria-label", "Dismiss");
    close.textContent = "×";

    el.appendChild(icon);
    el.appendChild(body);
    el.appendChild(close);
    stack.appendChild(el);

    requestAnimationFrame(function () { el.classList.add("is-in"); });

    function dismiss() {
      el.classList.remove("is-in");
      setTimeout(function () { el.remove(); }, 300);
    }
    close.addEventListener("click", dismiss);
    setTimeout(dismiss, TOAST_TIME);
  }

  // ─── Fake validation ─────────────────────────────────────────────────────
  function validate(value) {
    if (!value) {
      return "Email is required.";
    }
    if (value.indexOf("@") === -1) {
      return "Missing “@” — enter an address like name@domain.com.";
    }
    if (!emailPattern.test(value)) {
      return "That doesn't look like a valid email address.";
    }
    if (/@(test|example)\./i.test(value)) {
      return "Please use a real email address.";
    }
    return "";
  }

  document.querySelectorAll(".js-newsletter-form").forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var msg = form.querySelector("[data-newsletter-msg]");
    if (!input) {
      return;
    }
    var label = button ? button.textContent : "";

    function setError(text) {
      form.classList.remove("is-success");
      form.classList.add("is-error");
      input.setAttribute("aria-invalid", "true");
      if (msg) { msg.textContent = text; }
    }

    function clearError() {
      form.classList.remove("is-error");
      input.removeAttribute("aria-invalid");
      if (msg && !form.classList.contains("is-success")) { msg.textContent = ""; }
    }

    // Live feedback once the field has been touched
    input.addEventListener("blur", function () {
      var value = input.value.trim();
      if (value) {
        var error = validate(value);
        error ? setError(error) : clearError();
      }
    });
    input.addEventListener("input", function () {
      if (form.classList.contains("is-error")) { clearError(); }
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (form.classList.contains("is-sending")) { return; }

      var value = input.value.trim();
      var error = validate(value);

      form.classList.remove("is-success");

      if (error) {
        setError(error);
        toast("error", "Couldn't subscribe", error);
        input.focus();
        return;
      }

      clearError();
      form.classList.add("is-sending");
      input.disabled = true;
      if (button) {
        button.disabled = true;
        button.textContent = "Sending…";
      }

      // Fake request
      setTimeout(function () {
        form.classList.remove("is-sending");
        form.classList.add("is-success");
        if (msg) { msg.textContent = "✓ Subscribed. Thanks for reading!"; }
        if (button) { button.textContent = "✓ You're in!"; }
        toast("success", "You're in!", "A welcome email is on its way to " + value + ".");
      }, SEND_DELAY);
    });
  });
});
